var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowBackCoinera = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9771 12.7769C20.9771 12.2246 20.5293 11.7769 19.9771 11.7769H8.39126L13.6842 6.48396C14.0747 6.09344 14.0747 5.46027 13.6842 5.06975C13.2936 4.67922 12.6605 4.67922 12.2699 5.06975L5.26994 12.0697C4.87942 12.4603 4.87942 13.0934 5.26994 13.484L12.2699 20.484C12.6605 20.8745 13.2936 20.8745 13.6842 20.484C14.0747 20.0934 14.0747 19.4603 13.6842 19.0697L8.39126 13.7769H19.9771C20.5293 13.7769 20.9771 13.3291 20.9771 12.7769Z",
    fill: "#0B50EA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowBackCoinera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-back-coinera.19168334.svg";
export { ForwardRef as ReactComponent };